"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var polished_1 = require("polished");

var react_web_components_1 = require("@nimles/react-web-components");

var ShoppingCartMenu_1 = require("./ShoppingCartMenu");

var styled_1 = __importDefault(require("@emotion/styled"));

var ProductGroupsMenu_1 = require("./ProductGroupsMenu");

var Element_1 = require("./Element");

var UserMenu_1 = require("./UserMenu");

var Brand_1 = require("./Brand");

var StyledHeader = styled_1.default.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  z-index: 999;\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n"], ["\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  z-index: 999;\n  box-shadow: ", ";\n  background-color: ", ";\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.header.boxShadow;
}, function (_a) {
  var theme = _a.theme,
      backgroundColor = _a.backgroundColor;
  return backgroundColor || theme.header.background;
}, function (_a) {
  var theme = _a.theme,
      color = _a.color;
  return color || theme.header.color;
});
var Nav = styled_1.default.nav(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  padding: 0;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  padding: 0;\n"])));
var UpperNav = styled_1.default(Nav)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  height: 60px;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  height: 60px;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.primary.color;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.primary.onColor;
});
var LowerNav = styled_1.default(Nav)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  height: 50px;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  height: 50px;\n"])), function (_a) {
  var theme = _a.theme;
  return polished_1.lighten(0.1, theme.colors.primary.color);
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.primary.onColor;
});
var HeaderList = styled_1.default.ul(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));

exports.Header = function (_a) {
  var children = _a.children,
      layoutId = _a.layoutId,
      color = _a.color,
      backgroundColor = _a.backgroundColor;
  var tenant = react_redux_1.useSelector(function (_a) {
    var publicTenants = _a.publicTenants;
    return publicTenants.selected;
  });
  var layouts = react_redux_1.useSelector(function (_a) {
    var publicLayouts = _a.publicLayouts;
    return publicLayouts.values;
  });
  var layout = layouts && (layoutId && layouts.find(function (l) {
    return l.id === layoutId;
  }) || layouts.find(function (l) {
    return l.layoutType === 'Header';
  }));
  return react_1.default.createElement(StyledHeader, {
    color: color,
    backgroundColor: backgroundColor
  }, layout ? layout.elements && layout.elements.map(function (element) {
    return react_1.default.createElement(Element_1.Element, {
      key: element.id,
      tenant: tenant,
      element: element,
      root: "Header"
    });
  }) : children || react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(UpperNav, null, react_1.default.createElement(Brand_1.Brand, {
    showName: true,
    showLogo: true
  }), react_1.default.createElement(HeaderList, null), react_1.default.createElement(UserMenu_1.UserMenu, null)), react_1.default.createElement(LowerNav, null, react_1.default.createElement(ProductGroupsMenu_1.ProductGroupsMenu, null, "Sortiment"), react_1.default.createElement(react_web_components_1.Column, {
    flex: true
  }), react_1.default.createElement(ShoppingCartMenu_1.ShoppingCartMenu, null))));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;